const dev = {
  API_ENDPOINT_URL: 'https://bd9a-84-54-71-208.eu.ngrok.io/api/'
}
const prod = {
  API_ENDPOINT_URL: 'https://bd9a-84-54-71-208.eu.ngrok.io/api/'
};

const test = {
  API_ENDPOINT_URL: 'https://bd9a-84-54-71-208.eu.ngrok.io/api/'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
